import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { RadioButton } from 'components-ref/atoms'
import colors from 'styles/colors'

interface ContentFilterModalProps {
    filterList: string[]
    setActiveFilter: any
    closeFn: any
}

export function ContentFilterModal({
    filterList,
    setActiveFilter,
    closeFn
}: ContentFilterModalProps) {
    const [filter, setFilter] = useState(filterList[0])
    const { t } = useTranslation()
    function handleApply() {
        setActiveFilter(filter)
        closeFn()
    }
    return (
        <Container>
            {filterList.map((item, index) => (
                <FilterContainer key={index}>
                    {t(item)}
                    <RadioButton
                        clickFn={() => setFilter(item)}
                        active={filter === item}
                    />
                </FilterContainer>
            ))}
            <Apply onClick={handleApply}>{t('apply')}</Apply>
        </Container>
    )
}

const Container = styled.div`
    margin-top: 3rem;
    display: flex;
    flex-direction: column;
    z-index: 9999 !important
`

const FilterContainer = styled.div`
    width: 100%;
    padding: 0 1rem;
    margin: 0 auto 1.8rem;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 600;
    line-height: 17.07px;
    text-align: left;
    z-index: 9999 !important
`
const Apply = styled.button`
    border-radius: 1.6rem;
    padding: 0.9rem 5rem;
    background: ${colors.black157deg};
    border: 0;
    margin: 0rem auto;
    margin-top:1rem;

    color: ${colors.white};
    font-size: 14px;
    font-weight: 400;
    line-height: 17.07px;
    text-align: center;
z-index: 9999 !important
`
